/**
 * Created by phatbass on 2/9/16.
 */

angular.module('far.search')
    .controller('SearchClimberController', function ($timeout, $log, $http, $scope, form, autocomplete, userQualification, userAchievements, formsUtils) {
        var vm = {
            loaded: true,
            submitted: false,
            filterShow: true,
            form: {},
            userClimber: {
                offset: 0,
                limit: 100,
                data: []
            },
            total: {
                count: 0,
                pages: null
            },
            fistload: true,
            formSearchClimber: form('formSearchClimber'),
            clearFilters: clearFilters,
            submit: function ( next ) {
                if (vm.submitted) {
                    return false;
                }

                if ( !next ) {
                    vm.userClimber.offset = 0;
                    vm.userClimber.data = [];
                    vm.total.count = 0;
                    vm.total.pages = null;
                }

                var data = angular.merge({}, vm.form);
                if(1 > Object.keys(data).length){
                    if('' !== window.location.hash){
                        data = JSON.parse(decodeURIComponent(atob(window.location.hash.substring(1))));
                    }
                }
                this.data = data;
                window.location.hash = btoa(encodeURIComponent(JSON.stringify(data)));

                if ( angular.isObject( data.member ) ) {
                    data.member = data.member.id;
                }

                if ( angular.isObject( data.qualification ) ) {
                    data.qualification = data.qualification.id;
                }

                if ( angular.isObject( data.achievements ) ) {
                    data.achievements = data.achievements.id;
                }

                data['offset'] = vm.userClimber.offset;
                data['limit'] = vm.userClimber.limit;

                vm.submitted = true;

                $http.get(Routing.generate('api_climber_search', data)).then(function (response) {
                    vm.total.count = response.headers('X-Total-Count');
                    vm.total.pages = Math.ceil( vm.total.count / vm.userClimber.limit );

                    for ( var id in response.data ) {
                        response.data[ id ]['url'] = Routing.generate('user_view', {userId: response.data[ id].id});
                        vm.userClimber.data.push( response.data[ id ] );
                    }

                    vm.submitted = false;
                    vm.fistload = false;
                }, function errorCallback(response) {
                    $log.error(response);

                    vm.submitted = false;
                });
            },
            next: function () {
                vm.userClimber.offset += vm.userClimber.limit;

                vm.submit( true );
            },
            getTotalCount: function () {
                if (!vm.fistload) {
                    return formsUtils.numEnding( vm.total.count, ['Найден', 'Найдено', 'Найдено'] ) + ' ' + vm.total.count + ' ' + formsUtils.numEnding( vm.total.count, ['человек', 'человека', 'человек'] );
                }

                return '';
            }
        };

        if('' !== window.location.hash){
            vm.submit();
        }

        vm.formSearchClimber
            .addField('died', 'checkbox', {
                label: 'Память',
                options: {
                    ngChange: function () {
                        $timeout(function() {
                            vm.submit();
                        });
                    }
                }
            })
            .addField('achievements', 'selectObject', {
                validators: {
                    required: false
                },
                options: {
                    defaultOption: 'Квалификация и достижения',
                    class: 'form__item form__item_select width-200 margin_r_20',
                    ngChange: function () {
                        $timeout(function() {
                            vm.submit();
                        });
                    }
                },
                ngOptions: 'item as item.name for item in field.items track by item.id',
                label: null
            }, userAchievements.list)
            .addField('user_region', 'uiSelect', {
                validators: {
                    required: false
                },
                options: {
                    onSelect: 'field.uiSelectOptions.onSelect($item, $model)',
                    class: 'form__ui-select width-170 margin_r_20',
                    uiSelectManualClear: 'clearCitySelectEvent'
                },
                uiSelectOptions: {
                    matchTitle: '{{ $select.selected.name }} ',
                    choicesTitle: '{{ item.name }}',
                    match: {
                        placeholder: 'Регион',
                        allowClear: true
                    },
                    choices: {
                        repeat: 'item in field.items track by item.id',
                        refresh: 'field.uiSelectOptions.refreshAutoComplete($select.search, "UserCity", "user_region")',
                        refreshDelay: 0
                    },
                    refreshAutoComplete: autocomplete.refreshAutoComplete,
                    onSelect: function (item) {
                        vm.form.region = item ? item.name : null;

                        vm.submit();
                    }
                }
            }, autocomplete.get('user_region'))
            .addField('user_city', 'uiSelect', {
                validators: {
                    required: false
                },
                options: {
                    onSelect: 'field.uiSelectOptions.onSelect($item, $model)',
                    class: 'form__ui-select width-170 margin_r_20',
                    uiSelectManualClear: 'clearCitySelectEvent'
                },
                uiSelectOptions: {
                    matchTitle: '{{ $select.selected.name }} ',
                    choicesTitle: '{{ item.name }}',
                    match: {
                        placeholder: 'Город',
                        allowClear: true
                    },
                    choices: {
                        repeat: 'item in field.items track by item.id',
                        refresh: 'field.uiSelectOptions.refreshAutoComplete($select.search, "UserCity", "user_city")',
                        refreshDelay: 0
                    },
                    refreshAutoComplete: autocomplete.refreshAutoComplete,
                    onSelect: function (item) {
                        vm.form.city = item ? item.name : null;

                        vm.submit();
                    }
                }
            }, autocomplete.get('user_city'))
            .addField('qualification', 'selectObject', {
                validators: {
                    required: false
                },
                options: {
                    defaultOption: 'Разряд',
                    class: 'form__item form__item_select width-140 margin_r_20',
                    ngChange: function () {
                        $timeout(function() {
                            vm.submit();
                        });
                    }
                },
                ngOptions: 'item as item.name for item in field.items track by item.id',
                label: null
            }, userQualification.list)
            .addField('club', 'uiSelect', {
                validators: {
                    required: false
                },
                options: {
                    onSelect: 'field.uiSelectOptions.onSelect($item, $model)',
                    class: 'form__ui-select width-170 margin_r_20',
                    uiSelectManualClear: 'clearClubSelectEvent'
                },
                uiSelectOptions: {
                    matchTitle: '{{ $select.selected.name }} ',
                    choicesTitle: '{{ item.name }}',
                    match: {
                        placeholder: 'Федерация/Клуб',
                        allowClear: true
                    },
                    choices: {
                        repeat: 'item in field.items track by item.id',
                        refresh: 'field.uiSelectOptions.refreshAutoComplete($select.search, "Club", "club")',
                        refreshDelay: 0
                    },
                    refreshAutoComplete: autocomplete.refreshAutoComplete,
                    onSelect: function (item) {
                        vm.form.club = item ? item.id : null;

                        vm.submit();
                    }
                }
            }, autocomplete.get('club'))
            .addField('member', 'selectObject', {
                validators: {
                    required: false
                },
                options: {
                    defaultOption: 'Членство ФАР',
                    class: 'form__item form__item_select width-170',
                    ngChange: function () {
                        $timeout(function() {
                            vm.submit();
                        });
                    }
                },
                ngOptions: 'item as item.name for item in field.items track by item.id',
                label: null
            }, [{
                    id: 1,
                    name: 'Да'
                }, {
                    id: 0,
                    name: 'Нет'
                }]);

        function clearFilters() {
            $scope.$emit('clearClubSelectEvent');
            $scope.$emit('clearCitySelectEvent');
        }
        window.vm = vm;
        return vm;
    });
